import { Order } from '../types';

// Builds a short human-readable explanation of WHY the AI suggested the fee,
// from the persisted metadata (bulk class of the largest item + order value band).
// Returns a sentence ending in a trailing space so it can prefix the fine print,
// or '' when there's nothing to explain (e.g. older suggestions with no metadata).
export function suggestedFeeRationale(
  metadata?: Order['suggested_delivery_fee_metadata']
): string {
  if (!metadata) return '';

  if (metadata.status === 'needs_quote') {
    return 'The largest item was classified as oversized, which needs a manual quote. ';
  }

  const bits: string[] = [];
  if (metadata.bulk_class) bits.push(`the largest item (classified "${metadata.bulk_class}")`);
  if (metadata.value_band) bits.push(`an order value of ${metadata.value_band}`);
  if (bits.length === 0) return '';

  return `Based on ${bits.join(' and ')}. `;
}
